import { render, staticRenderFns } from "./FeeTablesV3.vue?vue&type=template&id=ec2bb5ec&"
import script from "./FeeTablesV3.vue?vue&type=script&lang=js&"
export * from "./FeeTablesV3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports